import { colors } from '../theme';

/** Полноэкранный просмотр фото — открывается кликом по миниатюре, закрывается кликом или Esc. */
export default function PhotoLightbox({ url, onClose }) {
  if (!url) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(6,10,22,0.92)', zIndex: 1000,
        display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-out', padding: 24,
      }}
    >
      <img src={url} alt="" style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: 8, boxShadow: '0 8px 40px rgba(0,0,0,0.5)' }} />
      <button
        onClick={onClose}
        style={{
          position: 'absolute', top: 20, right: 24, background: 'transparent', border: `1px solid ${colors.border}`,
          color: colors.text, borderRadius: 8, width: 36, height: 36, fontSize: 18, cursor: 'pointer',
        }}
      >
        ×
      </button>
    </div>
  );
}
